import { AxiosRequestConfig } from 'axios';
import {
	CashBalanceResponse,
	CashBalanceTransferRequest,
	CashBalanceTransferResponse,
} from '../types/cashBalance';
import { getApiUrl } from '../util/util';
import { get, patch } from './http';

const CashBalanceApi = {
	getCashBalance(
		authorizationToken: string,
		cashBalanceLocator: string,
		config?: AxiosRequestConfig<any>,
	) {
		return get<CashBalanceResponse>(
			`${getApiUrl()}/cashBalances/${cashBalanceLocator}`,
			authorizationToken,
			config,
		);
	},
	transferCashBalance(
		authorizationToken: string,
		cashBalanceLocator: string,
		cashBalance: CashBalanceTransferRequest,
	) {
		return patch<CashBalanceTransferResponse>(
			`${getApiUrl()}/cashBalances/${cashBalanceLocator}`,
			authorizationToken,
			cashBalance,
		);
	},
};

export default CashBalanceApi;
